import { Component, OnInit } from '@angular/core';
import { Contacto } from '../entities/contacto.entity';
import { environment } from '../../environments/environment';
import { Explotacion } from './../entities/explotacion.entity';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';
import { UsuarioOnline } from '../entities/UsuarioOnline.entity';
import { validate, ValidationError } from 'class-validator';
import { Router } from '@angular/router';

export interface FormModel {
  captcha?: string;
}
@Component({
  selector: 'app-contactpublic',
  styles: [`
  .error { color: crimson; }
  .success { color: green; }
` ],
  templateUrl: './contactpublic.component.html'
})
export class ContactpublicComponent implements OnInit {

  public name: string;
  public email: string;
  public asunto: string;
  public consulta: string;
  public contacto: Contacto;
  public usuario: UsuarioOnline;
  public poblacion: number;
  public tipo: string;
  public telefono: string;
  public direccion: string;
  public explotaciones: Explotacion[];
  public messageCabecera: string;
  public typeException: number;
  public messageComplet: string;
  public condicionesEnvio: string;
  public avisoEmail: string;
  public ubicacionOficina: string;
  public horario: string;
  public formModel: FormModel = {};
  public keyCapchasite: string;
  public captchaError: boolean;
  public nameInputError: boolean;
  public emailInputError: boolean;
  public poblacionInputError: Boolean;
  public politicas: Boolean;
  public asuntoInputError: Boolean;
  public consultaInputError: Boolean;
  public politicasInputError: Boolean;
  public telefonoInputError: Boolean;
  public tipoInputError: Boolean;
  public telefonoexplotacion: string;
  public pie: string;
  public isEmmasa: Boolean;

  constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    this.poblacion = -1;
    this.tipo = '-1';
    this.sessionService.datosExplotacion = new Explotacion();
    this.condicionesEnvio = 'Seleccione población';
    this.sessionService.datosExplotacion.CondicionesEnvio = null;
    this.explotaciones = this.sessionService.Explotaciones;
    if (this.explotaciones !== undefined && this.explotaciones.length === 1) {
      this.poblacion = 0;
      this.sessionService.datosExplotacion = this.explotaciones[0];
      this.cargarDatos();
    } else
      this.router.navigate(['/public/login']);
    this.keyCapchasite = environment.capchasiteKey;
    this.pie = environment.pie;
  }

  public enviar() {
    this.clearInputErrors();
    this.usuario = new UsuarioOnline();
    this.contacto = new Contacto();
    this.contacto.UsuarioOnline = new UsuarioOnline();
    this.usuario.Nombre = this.name;
    this.usuario.EMail = this.email;
    if (!this.isEmmasa) {
      this.contacto.Cuerpo = this.consulta;
      this.contacto.Asunto = this.asunto;
      // se indica para que pase la validación del telefono
      this.usuario.Telefono1 = '000000000';
    } else {
      this.contacto.Cuerpo = this.direccion !== undefined && this.direccion.length > 0 ?
        'Dirección: ' + this.direccion + '; ' + this.consulta : this.consulta;
      this.contacto.Asunto = this.tipo === '0' ? 'Duda' : this.tipo === '1' ? 'Reclamación' : 'Otros';
      this.usuario.Telefono1 = this.telefono;
    }
    if ((this.poblacion >= 0)) {
      this.usuario.Explotacion = this.explotaciones[this.poblacion].Codigo;
    }
    this.contacto.UsuarioOnline = this.usuario;
    this.contacto.gRecaptchaResponse = this.formModel.captcha;
    this.formModel.captcha = this.formModel.captcha === undefined ? null : this.formModel.captcha;

    validate(this.contacto).then(resultado => {
      if (resultado.length > 0 || !this.politicas || this.formModel.captcha === null) {
        this.showErrors(resultado);
      } else {
        if (document.getElementById('top') !== null)
          document.getElementById('top').scrollIntoView();
        this.userService.contactoPublico(this.explotaciones[this.poblacion].Codigo, this.contacto)
          .then(
            response => this.contactoOnSuccess(response),
            response => this.contactoOnError(response)
          );
      }
    });
  }

  public contactoOnSuccess(response) {
    this.messageCabecera = 'Mensaje enviado';
    this.typeException = 2;
    this.messageComplet = 'El mensaje se ha enviado correctamente. En breves recibiras una repuesta.';
    this.asunto = '';
    this.consulta = '';
  }

  public contactoOnError(response) {
    this.formModel.captcha = null;
    this.messageCabecera = 'Mensaje no enviado';
    this.typeException = 1;
    this.messageComplet = 'El mensaje no se ha enviado correctamente. Intentelo de nuevo en unos minutos o llámenos';
  }

  public cargarDatos() {
    if (this.poblacion !== -1) {
      this.sessionService.datosExplotacion = this.explotaciones[this.poblacion];
      this.telefonoexplotacion = this.explotaciones[this.poblacion].Contacto.substring(2, (this.explotaciones[this.poblacion].Contacto.length - 1));
      this.avisoEmail = 'Atención!!! La respuesta a su solicitud puede recibirla en la carpeta de correo no deseado.' +
        'En el caso de cuentas de correo de Hotmail, vemos necesario añadir previamente a sus contactos la cuenta ' +
        this.explotaciones[this.poblacion].Email + ' para asegurarse de que recibirá nuestros correos.';
      this.condicionesEnvio = this.explotaciones[this.poblacion].CondicionesEnvio;
      this.horario = this.explotaciones[this.poblacion].Horario;
      this.ubicacionOficina = this.explotaciones[this.poblacion].Domicilio + ' ' + this.explotaciones[this.poblacion].Contacto;
      this.isEmmasa = this.sessionService.datosExplotacion.Codigo === 'Emmasa';
    } else {
      this.sessionService.datosExplotacion = new Explotacion();
      this.sessionService.datosExplotacion.CondicionesEnvio = null;
      this.avisoEmail = null;
      this.condicionesEnvio = 'Seleccione población';
      this.horario = null;
      this.ubicacionOficina = null;
      this.isEmmasa = false;
    }
  }
  public showErrors(resultado: ValidationError[]) {
    for (let item of resultado) {
      switch (item.property) {
        case 'Asunto':
          this.asuntoInputError = true;
          break;
        case 'Cuerpo':
          this.consultaInputError = true;
          break;

      }
      for (let i of item.children) {
        switch (i.property) {
          case 'Explotacion':
            this.poblacionInputError = true;
            break;
          case 'Nombre':
            this.nameInputError = true;
            break;
          case 'EMail':
            this.emailInputError = true;
            break;
          case 'Telefono1':
            this.telefonoInputError = true;
        }

      }
    }
    if (this.formModel.captcha === null) {
      this.captchaError = true;
    }

    this.politicasInputError = !this.politicas;
    this.tipoInputError = this.tipo === '-1';
  }

  public clearInputErrors() {
    this.poblacionInputError = false;
    this.asuntoInputError = false;
    this.consultaInputError = false;
    this.politicasInputError = false;
    this.captchaError = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
  }

  // MODAL

  _showModalPolitica = false;

  showModal() {
    return this._showModalPolitica;
  }

  closeModal() {
    this._showModalPolitica = false;
  }
}

